import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { civilityOptions } from '../../../../../shared/utils/data/etablissments-data';
import { MissionService } from '../../../../../services/mission.service';
import { CandidatService } from '../../../../../services/candidat.service';
import { FlagService } from '../../../../../shared/services/flag.service';
import { CountryISO, NgxIntlTelInputModule, SearchCountryField } from '@justin-s/ngx-intl-tel-input';
import { SharedModule } from '../../../../../shared/shared.module';
import { FlagType } from '../../../../../shared/utils/enums';


@Component({
  selector: 'app-first-step-add-candidate',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SharedModule, NgxIntlTelInputModule,

  ],
  templateUrl: './first-step-add-candidate.component.html',
  styleUrl: './first-step-add-candidate.component.scss'
})
export class FirstStepAddCandidateComponent implements OnInit {
  @Input() form!: FormGroup;
  @Output() formValid = new EventEmitter<boolean>();
  @Input() loading: boolean = false;

  civilityOptions = civilityOptions;
  fonctionOptions: any[] = [];
  domaineOptions: any[] = [];
  image: string = '';
  formData: FormData = new FormData();
  user: any;
  maxDate: string;
  phoneMaxLength: number = 15;
  phoneNumber: string | undefined;

  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;

  constructor(
    private missionApi: MissionService,
    private candidatApi: CandidatService,
    private flag: FlagService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0];
    this.getPosts();
    this.getSecteur();
    this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : {};
    this.initForm();
    this.form.statusChanges.subscribe(() => {
      this.formValid.emit(this.form.valid);
    });
  }

  submitPhoto(id: any) {
    if (this.formData.has('photo1')) {
      this.candidatApi.uploadFileCandidat(this.formData, id).subscribe({
        next: (res) => {
          // Photo uploaded successfully
        },
        error: (err) => {
          this.formData.delete('photo');
          this.flag.displayFlag('Error !', FlagType.error);
        },
      });
    }
  }

  private initForm(): void {
    this.form.addControl('civility', this.fb.control('', Validators.required));
    this.form.addControl('firstname', this.fb.control('', Validators.required));
    this.form.addControl('lastname', this.fb.control('', Validators.required));
    this.form.addControl('birthDay', this.fb.control('', Validators.required));
    this.form.addControl('worktype', this.fb.control('', Validators.required));
    this.form.addControl('fonction', this.fb.control('', Validators.required));
    this.form.addControl('numtel', this.fb.control('', Validators.required));
    this.form.addControl('numsiret', this.fb.control(''));
    this.form.addControl('numsocialsecurity', this.fb.control(''));
    this.form.addControl('key', this.fb.control(''));
    this.form.addControl('ishandicap', this.fb.control(false));
    this.form.addControl('handicapsituation', this.fb.control(''));
    this.form.addControl('photo', this.fb.control(''));
  }

  getPosts() {
    if (this.form.get('worktype')?.value) {
      this.missionApi.getPostes(this.form.get('worktype')?.value).then((res) => {
        this.fonctionOptions = res;
      });
    } else {
      this.missionApi.getAllPostes().then((res) => {
        this.fonctionOptions = res;
      });
    }
  }

  getSecteur() {
    this.missionApi.getSecteurs().then((res) => {
      this.domaineOptions = res;
    });
  }

  getImage(event: any): void {
    if (event && event.length > 0) {
      const file = event[0];
      this.form.patchValue({ photo: file });
      if (this.formData.has('photo1')) {
        this.formData.set('photo1', file, file.name);
      } else {
        this.formData.append('photo1', file, file.name);
      }
    }
  }

  onInputChange(event: any): void {
    if (event) {
      this.form.patchValue({ numtel: event });
      this.phoneNumber = event.internationalNumber || event.number || '';
    }
  }

  onSiretInputChange(event: any): void {
    const value = event.target.value;
    if (value && value.length > 14) {
      event.target.value = value.slice(0, 14);
    }
  }

  onSecurityInputChange(event: any): void {
    const value = event.target.value;
    if (value && value.length > 13) {
      event.target.value = value.slice(0, 13);
    }
  }

  onKeyInputChange(event: any): void {
    const value = event.target.value;
    if (value && value.length > 2) {
      event.target.value = value.slice(0, 2);
    }
  }
}
